import { Fragment } from 'react';
import countries from '../../../assets/countries.json';
import { Text } from '../../FormControls/Text';
import { List } from '../../FormControls/List';

import { ScreenControl } from '../ScreenControl';

import { useDispatch, useSelector } from 'react-redux'
import { setCurrency } from '../../../../main/slices/bussinessSlice';

export const CurrencySelector = () => {

    function getCurrency(code){
        let currencies = {
            "GTM": [{name: "Quetzales" , id: "GTQ"}, {name: "Dolares", id: "USD"}],
            "HN": [{name: "Lempiras" , id: "HNL"}, {name: "Dolares", id: "USD"}],
            "SV": [{name: "Dolares", id: "USD"}],
            "PA": [{name: "Dolares", id: "USD"}],
            "CR": [{name: "Colones" , id: "CRC"}, {name: "Dolares", id: "USD"}],
        }
        return currencies[code]
    }

    const dispatch = useDispatch();
    const state = useSelector(({ bussines }) => bussines.currency);
    const country = useSelector(({ user }) => user.country);

    const handleChange = (value) => dispatch(setCurrency({ value, error: !value }));

    return (
        <Fragment>

            <Text classes={["subtitle"]}> ¿En qué moneda usarás Bitpos? </Text>
            <Text classes={["title"]}> Selecciona tu moneda de cobro </Text>

            <List
                def={state.value}
                items={getCurrency(country.value)}
                onSelect={(c) => handleChange(c)}
                keys={{ img: "flag", text: "name", id: "id" }}
            />

            <ScreenControl disabled={state.error} ></ScreenControl>

        </Fragment>
    )
}